<template>
  <!-- La pagina propone tutti i files che l'utente ha caricato nel tempo -->
  <!-- divisi per acquisto. -->
  <div>
    <!-- Modificatore della variabile act-for per richiedere dati di altre aziende -->
    <!-- associate al referente aziendale -->
    <SwitcherAziende/>

    <PageTagline :is_ref_azi_area="true" :elements="tagline_elem"/>

    <!-- Overlay di caricamento -->
    <CustomOverlay :show="overlay_show" text="Caricamento in corso, attendere...">

      <!-- CARD DI CONTENIMENTO DELLA PAGINA -->
      <b-card no-body class="mr-1 ml-1">
        <b-card-header>
          <h5><b-icon icon="files" class="mr-1"></b-icon> Gestione Files</h5>
        </b-card-header>
        <b-card-body>
          <!-- SELECT PER SCEGLIERE L'UTENTE DEL QUALE VISIONARE I FILES -->
          <b-row class="mb-1">
            <b-col>
              <p class="font-italic font-weight-bold">Seleziona l'utente da consultare:</p>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col md="3">
              <b-form-group id="group-select-utente"
                label="Utente da consultare"
                label-for="select-utente"
              >
                <b-form-select id="select-utente"
                  v-model="utente_sel"
                  :options="lista_utenti"
                  @change="carica_elementi">
                  </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>

          <!-- GRUPPO DI SELECT PER IL FILTRAGGIO DEGLI ELEMENTI -->
          <!-- La visualizziamo se è stato almeno selezionato un utente -->
          <div v-if="utente_sel != null">
            <b-row class="mb-1">
              <b-col>
                <p class="font-italic font-weight-bold">Seleziona almeno un valore se vuoi filtrare i files visualizzati:</p>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <!-- Filtro per id acquisto -->
              <b-col md="3">
                <b-form-group id="group-filtro-id-acq"
                  label="Id Pratica Welfare"
                  label-for="filtro-id-acq"
                >
                  <b-form-select id="filtro-id-acq"
                    v-model="filtro_id_acq_sel"
                    :options="filtro_id_acq"
                    @change="carica_elementi">
                    </b-form-select>
                </b-form-group>
              </b-col>
              <!-- Filtro per categoria di acquisto -->
              <b-col md="3">
                <b-form-group id="group-filtro-acq-categ"
                  label="Categoria Acquisto"
                  label-for="filtro-acq-categ"
                >
                  <b-form-select id="filtro-acq-categ"
                    v-model="filtro_acq_categ_sel"
                    :options="filtro_acq_categ"
                    @change="carica_elementi">
                    </b-form-select>
                </b-form-group>
              </b-col>
              <!-- Filtro per tipologia di files -->
              <b-col md="3">
                <b-form-group id="group-filtro-tipo-file"
                  label="Tipo File"
                  label-for="filtro-tipo-file"
                >
                  <b-form-select id="filtro_tipo_file"
                    v-model="filtro_tipo_file_sel"
                    :options="filtro_tipo_file"
                    @change="carica_elementi">
                    </b-form-select>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-button class="filter-reset-btn"
                          variant="primary"
                          @click="resetta_filtri_impostati"
                          :disabled="reset_button_disabled">
                          Resetta selezioni</b-button>
              </b-col>
            </b-row>
          </div>

          <!-- LISTA DEGLI ACQUISTI -->
          <!-- Per ogni riga ( cioè ogni acquisto ) impieghiamo una card -->
          <b-card class="mb-2" no-body v-for="(elem, index) in files_by_acq" :key="index">
            <b-card-header>
              <h6>Id Acquisto: <span class="font-italic font-weight-normal">{{elem.id}}</span></h6>
              <h6>Oggetto: <span class="font-italic font-weight-normal">{{elem.oggetto}}</span></h6>
            </b-card-header>
            <b-card-body>
              <!-- Aggiungiamo una b-row nel body della card all'interno del quale posizioniamo tante b-col -->
              <!-- quanti sono i files associati all'acquisto  -->
              <b-row>
                <b-col sm v-for="(file, index) in elem.files" :key="index">
                  <b-card no-body class="mx-auto mt-2" style="max-width:200px;">
                    <b-card-title class="mr-1 ml-1 mt-1 pt-2 text-center" style="font-size:1em">
                      <p>{{file.nome_file}}</p>
                    </b-card-title>
                    <b-card-body class="pr-1 pl-1 pt-1 pb-1">
                      <b-card-img :src="file.base64_thumb" alt="Image" class="rounded-0"></b-card-img>
                      <b-card-text class="mt-2 mb-2 text-center">
                        <p><em><small>{{file.tipo_file}}</small></em></p>
                        <b-button @click="scarica_documento(file.id_resource, index)" size='sm' variant='primary' ref="docs">
                          <b-icon icon="cloud-download" class="mr-1"></b-icon>Scarica il file
                        </b-button>
                      </b-card-text>
                    </b-card-body>
                  </b-card>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
          <!-- END - Riga Acquisto -->
          <!-- Se almeno un utente è stato selezionato ma non ci sono per  -->
          <!-- lui dei files da visualizzare allora mostriamo un messaggio -->
          <p v-if="utente_sel != null && files_by_acq.length === 0" class="text-center font-weight-bold">Nessun file trovato.</p>
        </b-card-body>
      </b-card>
    </CustomOverlay>
  </div>
</template>

<script>
import PageTagline from '@/components/PageTagline'
import SwitcherAziende from '@/components/refaziendale/SwitcherAziende.vue'
import CustomOverlay from '@/components/CustomOverlay'
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'
import fileDownload from 'js-file-download'

export default {
  name: 'RefFilesDash',
  data () {
    return {
      // Variabili generali
      tagline_elem : [ { text : "Gestione Files", link : 'office-user-files' } ],
      overlay_show : false,

      // I files divisi per id acquisto.
      files_by_acq : [],

      // Opzioni e valore selezionato per l'utente da visionare
      lista_utenti : [],
      utente_sel : null,

      // Opzioni filtro per tipo file e valore selezionato
      filtro_tipo_file : [],
      filtro_tipo_file_sel : null,

      // Opzioni filtro per tipo categoria di acquisto e valore selezionato
      filtro_acq_categ : [],
      filtro_acq_categ_sel : null,

      // Opzioni filtro per id acquisto e valore selezionato
      filtro_id_acq : [],
      filtro_id_acq_sel : null
    }
  },
  computed : {
    /**
     * Verifica lo stato di disabilitazione del pulsante di reset dei filtri
     * in base al settaggio dei filtri stessi.
     * Se almeno un filtro è settato il pulsante è abilitato.
     */
    reset_button_disabled : function () {
      if ( this.filtro_tipo_file_sel === null && this.filtro_acq_categ_sel === null && this.filtro_id_acq_sel == null ) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    /**
     * Dato il set dati iniziale riempiamo la select del filtro per tipo file
     * con tutti i tipi di files usati da questo utente.
     */
    inizializza_filtro_tipo_file : function () {

      // Un array di lavoro solo per vedere se il tipo di file lo abbiamo
      // già incluso.
      let id_tipo = new Array();

      // Resettiamo l'array e la ripopoliamo
      this.filtro_tipo_file = new Array();

      for ( let acq of this.files_by_acq ) {
        for ( let file of acq.files ) {
          if ( ! id_tipo.includes( file.id_tipo_file ) ) {
            id_tipo.push( file.id_tipo_file );
            this.filtro_tipo_file.push( { value : file.id_tipo_file, text: file.tipo_file } );
          }
        }
      }

      // Ordiniamo gli elementi per il testo nel tipo di files
      this.filtro_tipo_file.sort ( function ( a, b ) {
        if ( a.text < b.text ) return -1;
        if ( a.text > b.text ) return 1;
        return 0;
      });

      // Aggiungiamo in testa l'opzione fissa che invita a selezionare una tipologia
      this.filtro_tipo_file.unshift( { value: null, text: "Seleziona una tipologia", disabled: true } );

    },
    /**
     * Dato il set dati iniziale riempiamo la select del filtro per categoria dell'acquisto
     * con tutte le categorie di acquisto effettuate dall'utente.
     */
    inizializza_filtro_acq_categoria : function () {

      // Un array di lavoro per vedere se la categoria che stiamo controllando
      // è già stata inclusa
      let id_categ = new Array();

      // Resettiamo l'array e la ripopoliamo
      this.filtro_acq_categ = new Array();

      for ( let acq of this.files_by_acq ) {
        for ( let file of acq.files ) {
          if ( ! id_categ.includes( file.id_categ ) ) {
            id_categ.push( file.id_categ );
            this.filtro_acq_categ.push( { value : file.id_categ, text: acq.oggetto } );
          }
        }
      }

      // Ordiniamo gli elementi per il testo nel tipo di files
      this.filtro_acq_categ.sort ( function ( a, b ) {
        if ( a.text < b.text ) return -1;
        if ( a.text > b.text ) return 1;
        return 0;
      });

      // Aggiungiamo in testa l'opzione che invita a selezionare la categoria
      this.filtro_acq_categ.unshift( { value: null, text: "Seleziona una categoria", disabled: true } );

    },
    /**
     * Dato il set dati iniziale riempiamo la select del filtro per id acquisto
     * con gli id degli acquisti di questo utente.
     */
    inizializza_filtro_id_acquisto : function () {

      this.filtro_id_acq = new Array();

      for ( let acq of this.files_by_acq ) {
        let select_text = '[' + acq.id + '] ' + acq.oggetto;
        this.filtro_id_acq.push( { value : acq.id, text: select_text } );
      }

      // Ordiniamo gli elementi per id acquisto dal più nuovo
      // al più vecchio.
      this.filtro_id_acq.sort ( function ( a, b ) {
        if ( a.value > b.value ) return -1;
        if ( a.value < b.value ) return 1;
        return 0;
      });

      // Aggiungiamo in testa l'opzione fissa che invita a seleziona la pratica.
      this.filtro_id_acq.unshift( { value: null, text: "Seleziona un una pratica", disabled: true } );

    },
    /**
     * Resetta eventuali filtri impostati ed aggiorna la schermata
     * ricaricandone gli elementi.
     */
    resetta_filtri_impostati : function () {
      this.filtro_tipo_file_sel = null;
      this.filtro_acq_categ_sel = null;
      this.filtro_id_acq_sel = null;
      this.carica_elementi();
    },
    /**
     * Chiama il backend per caricare i dati da visualizzare quando le varie select
     * cambiano valore.
     */
    carica_elementi : function () {

      // Impostiamo innanzi tutto l'utente da visualizzare
      // se non selezionato non possiamo fare nulla.
      if ( this.utente_sel === null ) {
        this.$bvModal.msgBoxOk('Nessun utente selezionato, seleziona un utente per vedere i files.');
        return;
      }

      // Altrimenti iniziamo a preparare i parametri per la chiamata
      // prima l'uid utente e poi i filtri.
      let params = { uid :  this.utente_sel };

      // Tipo del file
      if ( this.filtro_tipo_file_sel != null ) {
        params.id_tipo_file = this.filtro_tipo_file_sel;
      }
      // Categoria di acquisto
      if ( this.filtro_acq_categ_sel != null ) {
        params.id_categoria = this.filtro_acq_categ_sel;
      }
      // Id dell'acquisto
      if ( this.filtro_id_acq_sel != null ) {
        params.id_ordine = this.filtro_id_acq_sel;
      }

      this.overlay_show = true;

      axios.get( apiUrl.documentsapi.ref_user_document_list, { params: params } )
      .then( (response) => {
        this.files_by_acq = response.data;

        // Aggiorna le select di filtro con i nuovi valiri caricati.
        this.inizializza_filtro_tipo_file();
        this.inizializza_filtro_acq_categoria();
        this.inizializza_filtro_id_acquisto();

        this.overlay_show = false;
      })
      .catch( (error) => {
          this.overlay_show = false;
          generalLib.backend_error_message_box( this, error.response.data );
      });
    },
    /**
     * Scarica il documento richiesto in base all'azienda selezionata
     * dal referente.
     *
     * - id_resource - L'id del documento da scaricare.
     * - index - L'indice che identifica il pulsante premuto.
     */
    scarica_documento : function ( id_resource, index ) {

      if ( this.utente_sel === null ) {
        this.$bvModal.msgBoxOk('Nessun utente selezionato, seleziona un utente per scaricare i files.');
        return;
      }

      // Disabilitiamo il pulsante sul quale l'utente ha premuto
      // sino a fine richiesta ( fa capo alla ref docs definita per i pulsanti )
      this.$refs.docs[index].disabled = true;

      let call_api = apiUrl.documentsapi.ref_user_download_document.replace( '@id_resource', id_resource );
      let params = { uid :  this.utente_sel };

      // Dobbiamo specificare ad axios che i dati che riceverà saranno
      // di tipo blob ( binary ) altrimenti il file scaricato risulterà
      // corrotto.
      axios.get( call_api, { responseType: 'blob', params: params }  )
      .then( ( response ) => {
        this.$refs.docs[index].disabled = false;
        // Prendiamo il nome dall'header content-disposition
        let nome_file = generalLib.get_nome_file( response );
        // Usiamo js-file-donwload per salvare il file sul client
        fileDownload( response.data, nome_file );
      })
      .catch( (error) => {
        this.$refs.docs[index].disabled = false;
        generalLib.backend_error_message_box( this, error.response.data );
      });
    }
  },
  /**
   * Alla creazione della vista chiamiamo il backend per avere la lista degli utenti
   * facenti parte dell'azienda in uso.
   */
  created : function () {
    this.overlay_show = true;

    // Prendiamo tutti gli utenti, anche quelli cessati, non applichiamo
    // quindi il filtro "solo_attivi"
    axios.get( apiUrl.welfareapi.anagrafica_utenti_by_azienda )
    .then( (response) => {
      // Riempio la select con le opzioni, devo dare come valore lo uid
      // e non l'id utente! Indico anche se l'utente è cessato o meno.
      for ( let utente of response.data ) {
        let select_text = utente.cognome + ' ' + utente.nome;
        if ( utente.is_cessato === 1 ) {
          select_text += ' - (Cessato)';
        }
        this.lista_utenti.push( { value : utente.uid, text: select_text } );
      }

      // Aggiungiamo in testa l'opzione fissa che invita a selezionare l'utente.
      this.lista_utenti.unshift( { value: null, text: "Seleziona un utente", disabled: true } );

      this.overlay_show = false;
    })
    .catch( (error) => {
        this.overlay_show = false;
        generalLib.backend_error_message_box( this, error.response.data );
    });
  },
  components : {
    PageTagline,
    CustomOverlay,
    SwitcherAziende
  }
}
</script>

<style scoped>
/* Stile per il bottone di reset dei filtri */
.filter-reset-btn {
  margin-top: 2em;
}

@media (max-width: 768px) {
  .filter-reset-btn {
    margin-top: 0px;
  }
}
</style>